<script>
import DataProvider from './DataProvider.vue';
import TeamRepository from '../../js/repository/TeamRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        teamId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: TeamRepository.findEmployees,
                params: [this.teamId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
